import { gql } from "@apollo/client";

export const GET_DSP_ADJUST_BILL_DETAILS = gql`
  query GetDspAdjustBillDetails($taskId: ID!, $page: Int!, $pageSize: Int!) {
    getDspAdjustBillDetails(taskId: $taskId, page: $page, pageSize: $pageSize) {
      list {
        id
        businessId
        adjustAmount
        beforeAdjustAmount
        diffAmount
        errorMsg
      }
      total
    }
  }
`;

export interface DspAdjustBillDetailItem {
  id: number;
  businessId: string;
  adjustAmount: number;
  beforeAdjustAmount: number | null;
  diffAmount: number | null;
  errorMsg: string | null;
}

export interface GetDspAdjustBillDetailsData {
  getDspAdjustBillDetails: {
    list: DspAdjustBillDetailItem[];
    total: number;
  };
}

export interface GetDspAdjustBillDetailsVariables {
  taskId: number;
  page: number;
  pageSize: number;
}
